import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useTranslation } from 'react-i18next'; // <-- 1. Import useTranslation
import './Header.css';
import logo from '../assets/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// 2. Import the new globe icon
import { faUserCircle, faUser, faSignOutAlt, faGlobe,faUsers,faFolder,faFileWaveform } from '@fortawesome/free-solid-svg-icons'; 

const Header = () => {
    const { user, logout } = useAuth();
    const { t, i18n } = useTranslation(); // <-- 3. Get t and i18n functions
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [dropdownRef]);

    // 4. Function to change the language
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    // 5. Set document direction based on language
    useEffect(() => {
        document.documentElement.dir = i18n.dir();
    }, [i18n, i18n.language]);

    return (
        <header className="app-header">
            <img src={logo} alt="Zakiya Logo" className="header-logo" />
            <div className="header-controls">
                {/* --- START: ADD LANGUAGE SWITCHER --- */}
                <div className="language-switcher">
                    <FontAwesomeIcon icon={faGlobe} className="globe-icon" />
                    <select onChange={(e) => changeLanguage(e.target.value)} value={i18n.language}>
                        <option value="en">EN</option>
                        <option value="ar">AR</option>
                    </select>
                </div>
                {/* --- END: ADD LANGUAGE SWITCHER --- */}

                <div className="profile-menu" ref={dropdownRef}>
                    <FontAwesomeIcon 
                        icon={faUserCircle} 
                        className="profile-icon" 
                        onClick={() => setDropdownOpen(!dropdownOpen)} 
                    />
                    {dropdownOpen && (
                        <div className="profile-dropdown">
                            <div className="dropdown-item profile-info">
                                <strong>{user.nationalId}</strong>
                                <small>{user.email}</small>
                            </div>
                            <div className="dropdown-divider"></div>
                            <div className="dropdown-item" onClick={() => alert('Profile page coming soon!')}>
                                <FontAwesomeIcon icon={faUser} className="dropdown-icon" /> {t('profile_menu_profile')}
                            </div>
                            <div className="dropdown-item" onClick={() => alert('Employee page coming soon!')}>
                                <FontAwesomeIcon icon={faUsers} className="dropdown-icon" /> {t('profile_menu_employee')}
                            </div>
                            <div className="dropdown-item" onClick={() => alert('Document Category page coming soon!')}>
                                <FontAwesomeIcon icon={faFolder} className="dropdown-icon" /> {t('profile_menu_documnet_category')}
                            </div>
                            <div className="dropdown-item" onClick={() => alert('Document page coming soon!')}>
                                <FontAwesomeIcon icon={faFileWaveform} className="dropdown-icon" /> {t('profile_menu_documnet')}
                            </div>
                            <div className="dropdown-item" onClick={logout}>
                                <FontAwesomeIcon icon={faSignOutAlt} className="dropdown-icon" /> {t('profile_menu_logout')}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
};

export default Header;